import { PartnerHomeNoticeModal } from "@/components/modal/PartnerHomeNoticeModal";
import { ParnerNoticePanel } from "@/components/panel/ParnerNoticePanel";
import { PartnerBuisinessGuidePanel } from "@/components/panel/PartnerBuisinessGuidePanel";
import { PartnerCustomerCenterPanel } from "@/components/panel/PartnerCustomerCenterPanel";
import { PartnerDiscountPanel } from "@/components/panel/PartnerDiscountPanel";
import { PartnerOrderStatusPanel } from "@/components/panel/PartnerOrderStatusPanel";
import { PartnerQuoteProgressPanel } from "@/components/panel/PartnerQuoteProgressPanel";
import { PageWrapper } from "@/components/wrapper/PageWrapper";

export const PartnerHomePage = () => {
  return (
    <PageWrapper>
      <div className="flex flex-col w-[1440px] gap-[24px]">
        <PartnerOrderStatusPanel />
        <div className="flex gap-[24px]">
          <PartnerQuoteProgressPanel />
          <PartnerDiscountPanel />
        </div>
        <div className="flex gap-[24px]">
          <ParnerNoticePanel />
          <PartnerBuisinessGuidePanel />
        </div>
        <div>
          <PartnerCustomerCenterPanel />
        </div>
      </div>
      <PartnerHomeNoticeModal />
    </PageWrapper>
  );
};
